import React from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import DrawerCustom from '../component/Drawer';
import { useGlobalState } from '../state';
import CallExclusionForm from './CallExclusionForm';
import EditButtons from './EditButtons'
import CAFWaitTimeThresholdMin from './CAFWaitTimeThresholdMin';

export default function OutboundContacts() {
  const [userAccessGroup] = useGlobalState('userAccessGroup')

  return (
    <Box sx={{ display: 'flex', marginTop: '10%' }}>
      <CssBaseline />
      <DrawerCustom />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
      <EditButtons sx={{ marginTop: '-3%' }} />
      <Grid item size={12} sx={{marginBottom:'2%'}}>     
      <CallExclusionForm />
      </Grid>
      {userAccessGroup === 'KMX-SSO-CCTWEBAPPS-CAF-USER-ROLE' ?
      <Grid item size={12}>
      <CAFWaitTimeThresholdMin />
      </Grid>
      : ""}           
    </Box >
    </Box >
  );
}